import dayjs from "dayjs";

export const getDayString = (shift = 0) => {
  return dayjs().add(shift, "day").format("YYYY-MM-DD");
};
